<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text">
            Delivery Orders Listings
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header"
        item-key="id"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :items="delivery_orders"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:[`item.date_time_added`]="item">
          <span>{{ item.item.date_time_added | formatDateTime }}</span>
        </template>
        <template v-slot:[`item.actions`]="item">
          <!--  <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="grey lighten-4 mx-2"
                @click="doAction({ item: item })"
                v-bind="attrs"
                v-on="on"
              > 
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>show items</span>
          </v-tooltip> -->
          <v-btn
            icon
            class="grey lighten-4 mx-2"
            @click="doAction({ item: item, name: 'veiw_charges' })"
          >
            <view-charge-sheet-dialog :selected_do="selected_do" />
          </v-btn>
          <!-- <v-btn
            icon
            class="grey lighten-4 mx-2"
            @click="doAction({ item: item, name: 'preview_charge_sheet' })"
          >
            <charge-sheet-dialog :selected_do="selected_do" />
          </v-btn> -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.item.is_verified && !item.item.is_printed"
                icon
                v-bind="attrs"
                v-on="on"
                class="grey lighten-4 mx-2"
                @click="doAction({ item: item, name: 'print_charge_sheet' })"
              >
                <print-charge-sheet-dialog :selected_do="selected_do" />
              </v-btn>
            </template>
            <span>Print Rating</span>
          </v-tooltip>
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="grey lighten-4 mx-2"
                v-bind="attrs"
                v-on="on"
                @click="doAction({ item: item, name: 'rate_again' })"
              >
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </template>
            <span>rate again</span>
          </v-tooltip>
-->
          <v-menu offset-y bottom left>
            <template v-slot:activator="{ on }">
              <!-- <v-icon small class="mr-2;" style="cursor: pointer" v-on="on">
                mdi-dots-vertical
              </v-icon>-->
              <v-btn icon class="grey lighten-4 mx-2" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(it, i) in menu_items" :key="i">
                <v-list-item-title
                  style="cursor: pointer;"
                  class=""
                  @click="doAction({ name: it.ref, item: item })"
                >
                  <v-icon>{{ it.icon }}</v-icon>
                  {{ it.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-col>
    <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text">
            Items For Delivery Order {{ do_number }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header_do_items"
        item-key="id"
        class="elevation-1"
        :search="search_item"
        :loading="loading_do_items"
        :items="delivery_order_items"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search_item"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-btn
            icon
            class="grey lighten-4 mx-2"
            @click="doAction({ item: item })"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-container>
</template>

<script>
//const addVessel = () => import("./add-vessel");
const viewChargeSheetDialog = () => import("./dialog-view-charge-sheet");
const printChargeSheetDialog = () => import("./dialog-print-charge-sheet");
//const chargeSheetDialog = () => import("./dialog_preview_do");
import { createNamespacedHelpers } from "vuex";
const departedVessel = createNamespacedHelpers("departed_vessels");
const deliveryOrderNamespace = createNamespacedHelpers("delivery_orders");
export default {
  components: {
    viewChargeSheetDialog,
    printChargeSheetDialog
    //chargeSheetDialog
  },
  data: () => ({
    activeItem: null,
    selected_do: null,
    menu: null,
    show: false,
    do_number: null,
    filteredList: null,
    search: "",
    search_item: "",
    menu_items: [
      { title: "View DO", ref: "view_do", icon: "mdi-eye-outline" },
      { title: "Show cargos", ref: "show_cargo", icon: "mdi-eye" },
      // { title: "Print", ref: "print_do", icon: "mdi-printer" },
      { title: "Rate Again", ref: "rate_again", icon: "mdi-reload" }
    ]
    // menu_items: [{ title: "view DO", ref: "view_do", view: "all" }]
  }),

  computed: {
    ...departedVessel.mapState({
      departed_vessels: state => state.departed_vessels,
      selected_vessel: state => state.selected_vessel
    }),

    ...deliveryOrderNamespace.mapState({
      delivery_orders: state =>
        state.delivery_orders ? state.delivery_orders : [],
      delivery_order_items: state => (state.do_items ? state.do_items : []),
      loading: state => state.loading,
      loading_do_items: state => state.loading_do_items
    }),

    header_do_items() {
      return [
        { text: "Cargo Number", value: "cargo_no" },
        { text: "Cargo Size", value: "cargo_size" },
        { text: "Cargo Type", value: "cargo_type" },
        { text: "Cargo Description", value: "cargo_description" },
        { text: "Seal Number", value: "seal_number" },
        { text: "Vehicle Tonnage", value: "vehicle_tonnage" },
        { text: "VIN Number", value: "vin_number" },
        { text: "Rated by", value: "current_username" }
        //{ text: "Action", value: "actions", align: "end", sortable: false }
      ];
    },

    header() {
      return [
        { text: "DO number", value: "do_number" },
        { text: "BL number", value: "bl_number" },
        { text: "Vessel Name", value: "vessel_name" },
        { text: "Consignee Fullname", value: "consignee_fullname" },
        // { text: "item_quantity", value: "item_quantity" },
        { text: "Total Charge", value: "total_charge" },
        { text: "Days Spent", value: "final_days_spend" },
        { text: "Rated Date", value: "date_time_added" },
        { text: "Rated by", value: "current_username" },
        {
          text: "Action",
          value: "actions",
          align: "end",
          sortable: false,
          width: "250px"
        }
      ];
    }
  },
  mounted() {
    this.loadDO();
    console.log("loading", this.loading);
  },
  methods: {
    ...deliveryOrderNamespace.mapActions([
      "fetchDeliveryOrders",
      "fetchDeliveryOrdersByVessel",
      "fetchDoItems",
      "asetDeliveryOrder"
    ]),
    doAction(item) {
      this.selected_do = item.item.item ? item.item.item : [];
      this.asetDeliveryOrder(this.selected_do);
      console.log("action", item.item);
      if (item.item) {
        if (
          item.name === "veiw_charges" ||
          item.name === "preview_charge_sheet"
        ) {
          this.viewCharges(item.item.item);
        } else if (item.name === "rate_again") {
          console.log("action - rate again", item.item);
          //this.asetDeliveryOrder(this.selected_do);
          this.$router.push("/traffic/rating/rate-again");
        } else if (item.name === "print_do") {
          console.log("print do");
        } else if (item.name === "view_do") {
          //this.asetDeliveryOrder(this.selected_do);
          this.$router.push("/traffic/view-do");
        } else {
          const do_id = item.item.item.id;
          this.fetchDoItems(do_id);
          this.do_number = item.item.item.do_number;
        }
      } else {
        return;
      }
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },
    viewCharges(item) {
      //this.asetDeliveryOrder(item);
      this.loadDOItems(item.id);
      console.log("view charges", item);
    },
    getDeliveryOrderSheet() {
      //
      console.log("do from jasper report server");
    },
    loadDO() {
      if (this.selected_vessel) {
        const id = this.selected_vessel.id;
        this.fetchDeliveryOrdersByVessel(id);
      } else {
        return;
      }
    },
    loadDOItems(id) {
      //console.log("action", item.item);

      if (id) {
        const do_id = id;
        this.fetchDoItems(do_id);
        this.do_number = this.do_number;
      } else {
        return;
      }
    }
  }
};
</script>

<style scoped>
.list {
  width: 100%;
}
</style>
